<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="قال-لقمان-الحكيم">
<h1>3<span dir="rtl">- قال لقمان الحكيم</span></h1>
<p><span dir="rtl">نصحَ لقمانُ الحكيمُ</span></p>
<p><span dir="rtl">شرحتُ الجدرانَ</span></p>
<p><span dir="rtl">تفاعلتِ الأشجارُ</span></p>
<p><span dir="rtl">بكى الترابُ وصمتَ</span></p>
<p><span dir="rtl">قالَ لقمانُ الحكيمُ</span></p>
<p><span dir="rtl">تُصبِحون على خيرٍ</span></p>
<p><span dir="rtl">حانَ وقتُ الاستيقاظِ</span></p>
<p><span dir="rtl">إنَّه الغروبُ</span></p>
<p><span dir="rtl">الحجرُ وخز الإبر</span></p>
<p><span dir="rtl">الصبرُ ينبتُ بعضه</span></p>
<p><span dir="rtl">هل قالَ الحكيمُ بلا ماءٍ؟</span></p>
<p><span dir="rtl">عادَ الترابُ ليصمتَ</span></p>
<p><span dir="rtl">عندما تمطرُ الغيومُ يتمُّ الحصادُ</span></p>
<p><span dir="rtl">وحين ينامُ القمحَ على البيادرِ</span></p>
<p><span dir="rtl">ترحلُ السُّنونو</span></p>
<p><span dir="rtl">تكلَّمَ الحكيمُ تحتَ أَسِرَّةِ الفقراءِ</span></p>
<p><span dir="rtl">قالَ الحكيمُ:</span></p>
<p><span dir="rtl">ازرعوا الحكمةَ على رفوفِ المطابخِ</span></p>
<p><span dir="rtl">دعُوا الصبرَ بين الإبرِ</span></p>
<p><span dir="rtl">هل ينبتُ البشرُ تحتَ الأسِرَّةِ</span></p>
<p><span dir="rtl">بلا وخزِ الإبرِ؟</span></p>
<p><span dir="rtl">قالَ الحكيمُ:</span></p>
<p><span dir="rtl">إن تكلَّمَتِ الجدرانُ تكلَّمتُ</span></p>
<p><span dir="rtl">وبينَ الاستيقاظِ والغروبِ</span></p>
<p><span dir="rtl">تصحو الغيومُ على النصيحةِ</span></p>
<p><span dir="rtl">ينتظرُ قمحُ البيادرِ</span></p>
<p><span dir="rtl">وتنتظرُ السُّنونو والعصافيرُ</span></p>
<p><span dir="rtl">قولًا على قولِ الحكيمِ</span></p>
<p><span dir="rtl">تأتي الفصولُ على عجلٍ</span></p>
<p><span dir="rtl">يأتي الخريفُ على عجلٍ</span></p>
<p><span dir="rtl">يأتي الشتاءُ على عجلٍ</span></p>
<p><span dir="rtl">يأتي الربيعُ على عجلٍ</span></p>
<p><span dir="rtl">متى تخرجُ البذرةُ مِن تحتِ السرير؟</span></p>
<p><span dir="rtl">تُصبِحون على خيرٍ</span></p>
<p><span dir="rtl">لقد حانَ وقتُ الاستيقاظِ</span></p>
<p><span dir="rtl">صباحُ النورِ</span></p>
<p><span dir="rtl">أَحضِروا الوسادةَ</span></p>
<p><span dir="rtl">أريدُ أن أنامَ</span></p>
<p><span dir="rtl">أحمد كريم عز الدين.. سوريا</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch008.vue?f8b43b5c